import { CreateInteractivity } from 'components/minute/sidebar/interactivity/InteractivitySidebar/CreateInteractivity';
import { EditInteractivity } from 'components/minute/sidebar/interactivity/InteractivitySidebar/EditInteractivity';
import { Message } from 'elements/minute/sidebar/sidebarComponents/atomic/Message';
import { motion } from 'framer-motion';
import { useWorldMarker } from 'hooks/marker/useWorldMarker';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const InteractivitySidebar = (props: Props): JSX.Element => {
    const worldMarker = useWorldMarker();
    const selectedMarker = worldMarker.getSingleMarkerIfOne();
    const storyIds = selectedMarker.storyIds ?? [];

    return (
        <S_InteractivitySidebar className={props.className} key={storyIds[0]}>
            <motion.div {...ANIMATION_APPEAR}>
                {storyIds.length === 0 && <CreateInteractivity />}
                {storyIds.length === 1 && (
                    <EditInteractivity key={storyIds[0]} detailId={storyIds[0]} />
                )}
                {storyIds.length > 1 && (
                    <Message type="warning">
                        This marker has multiple interactivity events which are uneditable in this
                        editor
                    </Message>
                )}
            </motion.div>
        </S_InteractivitySidebar>
    );
};

const S_InteractivitySidebar = styled.div``;
